export default __webpack_public_path__ + "static/media/white_person.8a655673.svg";